<template>
  <div id="footer" class="container-fluid">
    <h3>联系我们</h3>
    <div class="line-class" style="margin: 20px 50px 30px 50px"></div>
    <p class="email_wx">
      <span style="font-size: 18px">{{ companyList.companyName }}</span>
    </p>

    <p class="email_wx">
      <span>地址:{{ companyList.companyAddress }}</span>
    </p>
    <p class="email_wx">
      <a
        style="color: #d3d3d3; font-size: 13px"
        href="mailto:marketing@leosue.com "
        >邮箱:{{ companyList.companyEmail }}
      </a>
    </p>
    <p class="email_wx">
      <a
        style="color: #d3d3d3; font-size: 13px"
        href="mailto:marketing@leosue.com "
        >电话:{{ companyList.companyPhone }}
      </a>
    </p>
    <div class="text-center" style="width: 100%">
      <div class="text-center" style="width: 100%">
        <span>官方微信</span>
        <img
          class="center-block"
          style="width: 100px; margin-top: 20px"
          :src="companyList.companyWechat"
          alt="引号"
        />
      </div>
      <div class="text-center" style="margin-bottom: 20px; margin-top: 10px">
        <a
          target="_blank"
          style="color: #d3d3d3; font-size: 13px"
          href="https://beian.miit.gov.cn/index#/Integrated/index"
          >{{ companyList.companyRecord }}</a
        >
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {
      id: 11,
      companyList: {
        companyName: "上海里数网络科技有限公司",
        companyAddress: "上海市闵行区吴中路1439号莱茵虹景中心A栋605室",
        companyEmail: "marketing@leosue.com",
        companyWechat:
          "https://leosue-cms.oss-cn-beijing.aliyuncs.com/images/20230602/9ac45f81529542d3bc111eb988bc53d37236e190-5b5d-4810-a36f-37ee65aba9dc.png",
        companyPhone: "021-54315878",
        companyRecord: "沪ICP备18020150号-1 Copyright @ 2016 里数科技",
        companyLogo:
          "https://leosue-cms.oss-cn-beijing.aliyuncs.com/images/20230630/811a3c605cfb44b28fc07f2aef8a7aeb微信图片_20230630151600.png",
      },
    };
  },
  created() {
    this.getCompany();
  },
  methods: {
    getCompany() {
      this.http({
        method: "post",
        url: "/cms/api/CompanyInfo/companyInfoselect",
        data: {
          id: "11",
        },
      }).then((res) => {
        if (res.data.code == 200) {
          this.companyList = res.data.data;
        }
      });
    },
  },
};
</script>
<style scoped>
a {
  text-decoration: none;
}
#footer {
  width: 100%;
  height: 100%;
  color: #fff;
  background: #083055;
  overflow: hidden;
  text-align: center;
}
.line-class {
  height: 1px;
  background-color: #eeeeee;
  margin-top: 10px;
  margin-bottom: 10px;
}
.logo {
  width: 95px;
  height: 45px;
  margin: 50px auto 20px;
}
.title {
  font-size: 25px;
  margin-bottom: 20px;
}
.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0;
}
.email_wx {
  color: #d3d3d3;
  font-size: 14px;
}
.copy {
  color: #d3d3d3;
  font-size: 14px;
  margin: 50px 0 10px;
}
@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }
  .address_tel_fax {
    font-size: 12px;
  }
  .email_wx {
    font-size: 12px;
  }
  .copy {
    font-size: 12px;
    margin: 30px 0 10px;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue